import { render } from "./empty_display.vue?vue&type=template&id=2d0e95b8"
import script from "./empty_display.vue?vue&type=script&lang=js"
export * from "./empty_display.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__